import { getConfig } from '@cian/config/browser';
import { getLogger } from '@cian/logger/browser';
import { mergePaths, transformObjectToQuery } from '../../../shared/URI/helpers.mjs';
import { parseURI } from '../../../shared/URI/parsers.mjs';
import '@cian/peperrors/shared';
import { camelCaseToKebabCase, kebabCaseToCamelCase, isLowerCase } from '../../../shared/internal/wordsCase/wordsCase.mjs';

class URI {
    model;
    subdomain;
    transformBodyToLegacyString;
    parsedURI;
    constructor(params) {
        this.model = params.model;
        this.subdomain = params.subdomain;
        this.transformBodyToLegacyString = params.transformBodyToLegacyString;
        const config = getConfig();
        this.parsedURI = parseURI(getBaseUrlFromConfig(config, this.model));
    }
    get scheme() {
        return this.parsedURI.scheme;
    }
    get host() {
        if (this.subdomain) {
            return `${this.subdomain}.${this.parsedURI.host}`;
        }
        return this.parsedURI.host;
    }
    get port() {
        return this.parsedURI.port;
    }
    get path() {
        return mergePaths(this.parsedURI.path, this.model.pathApi);
    }
    get query() {
        const { method, parameters } = this.model;
        if (method !== 'GET' || !parameters) {
            return undefined;
        }
        return transformObjectToQuery(parameters, this.transformBodyToLegacyString);
    }
}
function getBaseUrlFromConfig(config, model) {
    if (model.apiType === 'external') {
        return config.getStrict(`${model.microserviceName}.externalUrl`);
    }
    const { hostType = 'api', microserviceName } = model;
    const mcsRunEnvType = config.get('mcsRunEnvType');
    const hostPart = hostType === 'ud-api' ? 'udApiBrowserUrl' : 'browserUrl';
    let baseServiceUri = config.get(`${microserviceName}.${hostPart}`);
    if (baseServiceUri) {
        if (process.env.NODE_ENV === 'development') {
            const microserviceNameKebabCase = camelCaseToKebabCase(microserviceName);
            if (!config.get(`${microserviceNameKebabCase}.${hostPart}`)) {
                const logger = getLogger();
                logger.warning(`В настройке "${microserviceName}.${hostPart}" используется неправильная нотация для имени микросервиса`);
                logger.warning(`Имя микросервиса необходимо указывать в kebab-case: "${microserviceNameKebabCase}.${hostPart}"`);
            }
        }
        return baseServiceUri;
    }
    const microserviceNameCamelCase = kebabCaseToCamelCase(microserviceName);
    baseServiceUri = config.get(`${microserviceNameCamelCase}.${hostPart}`);
    if (baseServiceUri) {
        if (process.env.NODE_ENV === 'development') {
            const logger = getLogger();
            const microserviceNameKebabCase = camelCaseToKebabCase(microserviceName);
            logger.warning(`В настройке "${microserviceNameCamelCase}.${hostPart}" используется неправильная нотация для имени микросервиса\n`);
            logger.warning(`Имя микросервиса необходимо указывать в kebab-case: "${microserviceNameKebabCase}.${hostPart}"`);
        }
        return baseServiceUri;
    }
    const microserviceNameKebabCase = camelCaseToKebabCase(microserviceName);
    if (model.apiType === 'legacy') {
        return config.getStrict(`${microserviceNameKebabCase}.${hostPart}`);
    }
    const mcsRunEnv = config.getStrict('mcsRunEnv');
    if (process.env.NODE_ENV === 'development') {
        if (microserviceNameKebabCase !== microserviceName && !isLowerCase(microserviceName)) {
            getLogger().warning(`В модели используется неправильная нотация для имени микросервиса.\n` +
                `Текущее имя: "${microserviceName}", правильное: ${microserviceNameKebabCase}`);
        }
    }
    switch (mcsRunEnvType) {
        case 'dev':
        case 'local':
            return `https://master.api.dev3.cian.ru/${microserviceNameKebabCase}/`;
        case 'beta':
            return `https://api.${mcsRunEnv.replace('-', '')}.stage.cian.ru/${microserviceNameKebabCase}/`;
        default:
            return `https://${hostType}.cian.ru/${microserviceNameKebabCase}/`;
    }
}

export { URI, getBaseUrlFromConfig };
//# sourceMappingURL=URI.mjs.map
